import React from 'react';
import { Challenge } from '../../../model/interfaces';
import { t } from '@base/utils/helpers';
import styles from './challengesList.module.scss';

export default function ChallengesList(props: {
  challenges: Challenge[];
  onClick: (challenge: Challenge) => void;
}) {
  return (
    <ul>
      {props.challenges.map((challenge) => (
        <div
          className={styles.row}
          onClick={() => props.onClick(challenge)}
          key={challenge.id}
        >
          <span>{challenge.issuerName}</span>
          <span className={styles.vs}>
            <svg
              width="8"
              height="15"
              viewBox="0 0 8 15"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path d="M1 1L6.5 8L1 14.5" stroke="white" strokeWidth="1.5" />
            </svg>
            {t('vs')}
          </span>
          <span>{challenge.recipientName}</span>
        </div>
      ))}
    </ul>
  );
}
